module.exports = __webpack_public_path__ + "img/doctor.fbc14657.png";